/**
 * Détection de l'environnement Median et des capacités de stockage natif
 */

export function hasNativeDatastore(): boolean {
  return !!(
    typeof window !== 'undefined' &&
    (window as any).median &&
    (window as any).median.storage &&
    (window as any).median.storage.app
  );
}

export function hasCloudStorage(): boolean {
  return !!(
    typeof window !== 'undefined' &&
    (window as any).median &&
    (window as any).median.storage &&
    (window as any).median.storage.cloud
  );
}

export function isMedianApp(): boolean {
  return !!(
    typeof window !== 'undefined' &&
    (window as any).median
  );
}

export function getMedianInfo(): { isMedian: boolean; hasNative: boolean; hasCloud: boolean } {
  return {
    isMedian: isMedianApp(),
    hasNative: hasNativeDatastore(),
    hasCloud: hasCloudStorage()
  };
}
